export interface ClientIntegrationIdentifier {
    clientName: string;
    integrationType: string;
}

export interface ClientIntegrationIdentifierExt extends ClientIntegrationIdentifier {
    version: ClientIntegrationIdentifierVersion;
}

export enum ClientIntegrationIdentifierVersion {
    V1 = 'V1',
    V2 = 'V2'
}

export interface ClientIntegrationVersionIdentifier extends ClientIntegrationIdentifier {
    version: string | null;
    fromArchived?: boolean;
}

export interface IntegrationNewVersionResponse {
    filenames: string[];
    errorMessage: string | null;
}
